import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { Collapse } from '@dapp/multi-lib/sdaoui/Collapse';
import { useState } from 'react';
import { ButtonIcon } from '@dapp/multi-lib/sdaoui/ButtonIcon';
import { Body1, Body2, Header2 } from 'structure/home/components/Typography';

interface MigrationGuideProps {
  anchorId: string;
}

export const MigrationGuide = ({ anchorId }: MigrationGuideProps) => {
  return (
    <div id={anchorId} className='flex flex-col gap-6'>
      <Header2>Merger Details</Header2>

      <Body1 as='div'>
        <ul className='list-outside list-disc pb-10 pl-4'>
          <li className='py-0.5'>
            <b>Merger announcement and litepaper release: </b>
            15 October 2024
          </li>
          <li className='py-0.5'>
            <b>SingularityDAO Governance Vote Period: </b>9th December 2024
            (12:00 PM UTC) – 13th December 2024 (12:00 PM UTC)
          </li>
          <li className='py-0.5'>
            <b>Vote Result Announcement: </b>14th December 2024
          </li>
          <li className='py-0.5'>
            <b>Phase 1 Migration starts: </b>6th February 2025
          </li>
        </ul>
        <p className='pb-2'>
          <b>Conversion ratios:</b> The token conversion ratios for the
          migration to SFI are as follows:
        </p>
        <ul className='list-outside list-disc pl-4'>
          <li className='py-0.5'>
            SDAO will convert to SFI at a ratio of 1:1 (1 SDAO = 1 SFI)
          </li>
          <li className='py-0.5'>
            CGV will convert to SFI at a ratio of 1:0.14122 (1 CGV = 0.14122
            SFI)
          </li>
          <li className='py-0.5'>
            KEY will convert to SFI at a ratio of 800:1 (800 KEY = 1 SFI)
          </li>
        </ul>
        <Body1 className='text-[0.75rem] italic lg:text-[0.75rem] xl:text-[0.75rem]'>
          *Ratios are calculated based on the 200-day moving average of each
          token up to 26th November 2024.
        </Body1>
      </Body1>
    </div>
  );
};

interface CollapsibleBlockProps {
  title: string;
  description: string;
  children?: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CollapsibleBlock = (props: CollapsibleBlockProps) => {
  const { title, description, children } = props;

  const [opened, setOpened] = useState<boolean>(false);

  return (
    <div>
      <div className='gap flex flex-row items-start gap-2 xl:items-center'>
        <div className='flex flex-col flex-wrap items-start gap-2 xl:flex-row xl:items-center'>
          <Body1 className='font-bold text-[#92A0AA]'>{title}</Body1>
          <Body1>{description}</Body1>
        </div>

        {children ? (
          <ButtonIcon
            className='ml-auto'
            onClick={() => setOpened((prev) => !prev)}
          >
            <Icon
              icon={opened ? 'minus' : 'plus'}
              width={24}
              height={24}
              color='white'
            />
          </ButtonIcon>
        ) : null}
      </div>

      {children ? (
        <Collapse visible={opened} type='vertical'>
          <Body2 className='text-base text-[#818181]'>{children}</Body2>
        </Collapse>
      ) : null}
    </div>
  );
};
